import { Pipe, PipeTransform } from '@angular/core';

import { FileImageExtension, IResidentS3File } from '../models';
import { getFileExtensionFromPath, isImage, isPdf } from '../utils';

@Pipe({
  name: 'isImage',
  standalone: true,
})
export class IsImagePipe implements PipeTransform {
  transform(value: IResidentS3File | string | undefined): boolean {
    const extension: FileImageExtension | string | undefined =
      typeof value === 'string'
        ? value.includes('.')
          ? getFileExtensionFromPath(value)
          : value
        : value?.extension
          ? value.extension
          : value?.url
            ? getFileExtensionFromPath(value.url)
            : undefined;

    return isImage(extension);
  }
}

@Pipe({
  name: 'isPdf',
  standalone: true,
})
export class IsPdfPipe implements PipeTransform {
  transform(value: IResidentS3File | string | undefined): boolean {
    const extension: FileImageExtension | string | undefined =
      typeof value === 'string'
        ? value.includes('.')
          ? getFileExtensionFromPath(value)
          : value
        : value?.extension // Check extension property first
          ? value.extension
          : value?.url
            ? getFileExtensionFromPath(value.url)
            : undefined;

    return isPdf(extension);
  }
}
